var n=function(n){return n&&"number"==typeof n.length&&"function"!=typeof n};export{n as isArrayLike};
